import { Pipe, PipeTransform } from '@angular/core';
import { ConfigConditionService } from '@app/reports/report/config-condition.service';
import { ITableColumn, ITableData } from '@app/reports/report/config-report.interface';

@Pipe({ name: 'condition' })
export class ConditionPipe implements PipeTransform {
  constructor(private configConditionService: ConfigConditionService) {}

  public transform(
    conditionName: string,
    item: ITableColumn,
    data: ITableData[],
    currentIndex: number,
    args: { [key: string]: any; } = {},
  ) {
    if (!conditionName) return false;
    return this.configConditionService.evaluateCondition(conditionName, item, data, currentIndex, args);
  }
}